import React, { useState } from "react"
import { Table } from "antd"

export const UserTrackUsageTable = ({ dataProps }) => {
  const { data, columns, loading, selectionMode, onSelectionChange, selectedRows } = dataProps
  const [pageSize, setPageSize] = useState(10)

  const handlePageSizeChange = (current, size) => {
    setPageSize(size)
  }

  const getRowKey = (record) => {
    return `${record._id.year}-${record._id.month}-${record._id.day}-${record.user_info.email}`;
  };

  const rowSelection = selectionMode
    ? {
        selectedRowKeys: selectedRows.map(getRowKey),
        onChange: (selectedRowKeys, selectedRows) => {
          onSelectionChange(selectedRowKeys, selectedRows);
        },
      }
    : undefined;

  return (
    <div className="mt-2">
      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey={getRowKey}
        rowSelection={rowSelection}
        scroll={{ x: true}}
        bordered
        responsive
        pagination={{
          pageSize: pageSize,
          showSizeChanger: true,
          showQuickJumper: false,
          pageSizeOptions: ["10", "20", "30", "40", "50"],
          onShowSizeChange: handlePageSizeChange,
        }}
        className="custom-table"
      />
    </div>
  )
}

export default UserTrackUsageTable

